import { createSelector } from "reselect";
import { isEmpty, forIn, isNull } from "lodash";

const defaultUserProfile = {
  education: null,
  jobType: null,
  employedIn: null,
  income: null
};
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const userProfile = state.profile.info;
  //get all static data
  const { data } = state;
  //if any of the static data is empty return the default value
  if (
    isEmpty(data.education) ||
    isEmpty(data.jobType) ||
    isEmpty(data.employedIn) ||
    isEmpty(data.income)
  ) {
    return defaultUserProfile;
  }
  //if preference is empty return the default value
  if (isEmpty(userProfile)) {
    return defaultUserProfile;
  }
  //format the preference and return it
  try {
    let object = {};
    forIn(userProfile, (value, key) => {
      if (key === "education") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "jobType") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "employedIn") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "income") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else {
        //do nothing
      }
    });
    return object;
  } catch (error) {
    return defaultUserProfile;
  }
};
//VERIFY IF THE JWT IS SET
const getMemberEducationProfile = createSelector(
  getData,
  userProfile => userProfile
);
export default getMemberEducationProfile;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberEducationProfile.js